/* eslint-disable react/self-closing-comp */
import React, { useState, useEffect, useRef } from 'react'

import {
    Box,
    Button,
    Typography,
    Link,
    InputAdornment,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Tooltip,
    IconButton,
    TextField,
    FormControl,
    FormHelperText,
    Chip,
    FormControlLabel,
    Checkbox,
    Grid,
    Stack
} from '@mui/material';

import dayjs from 'dayjs';
import * as yup from 'yup';

import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { Barcode, svgToPngDataUrl } from './section/Barcode';

import CommonBreadcumbs from "../../../../../components/common/CommonBreadcumbs"

// import DataGridRowActionMenu from '../../../../../components/common/DataGridRowActionMenu';
import DataGridTable from '../../../../../components/common/DataGridTable';
import DataGridToolbar from '../../../../../components/common/DataGridToolbar';
import CommonRestricted from '../../../../../components/common/CommonRestricted';
import { CommonPdf, renderModes, documentTypes as commonPdfDocumentTypes } from '../../../../../components/common/CommonPdf';
import DatePickerComponent from "../../../../../components/common/DatePickerComponent";

// import { getEnvConfigs } from "../../../../../configs/envConfigs"

import { useAppContextFeatures } from '../../../../../context/AppContext';
import { useSystemPrompt } from "../../../../../hooks/useSystemPrompt";
import { useAuthAccess } from "../../../../../hooks/useAuthAccess";
import { useTranslations } from '../../../../../hooks/useTranslations';

import {
    useDataGridParams,
    dataGridFilterTypes,
    dataGridFilterTypesProps
} from '../../../../../hooks/useDataGridParams';

import { useSystemRoutes, routeTypes } from '../../../../../hooks/useSystemRoutes';
import { CommonIcons, icons } from "../../../../../components/common/CommonIcons"
import { useSystemHead } from '../../../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../../../hooks/usePermissions';

import { useProduct, productInjectionFields, productLoadStatusTypes } from '../../../hooks/model/useProduct';
import { useContainer } from '../../../hooks/model/useContainer';
import { useProductItem, itemInjectionFields } from '../../../hooks/model/useProductItem';

import { getInjectionDataType } from "../../../utils/injectionSelection"

import styles from '../../../styles/datagrid.module.css'

export const validationSchema = yup.object({
    searchBarcode: yup
        .string()
        .required("Required"),
})

const initialValues = {
    searchBarcode: ""
}

const validationPrintLabelsRowSchema = yup.object({
    id: yup.string()
        .required("Required"),
    printNo: yup
        .string()
        .required("Required")
        .test("is-positive-number", "Must be a number greater than 0", (value) => {
            const number = Number(value);
            return !Number.isNaN(number) && number > 0;
        }),
});

const validationPrintLabelsSchema = yup.object({
    rows: yup.array().of(validationPrintLabelsRowSchema),
})

const initialPrintLabelsValues = {
    rows: []
}

const initialFilterDateValues = {
    fromDate: dayjs().subtract(6, "month").startOf("day"),
    toDate: dayjs().endOf("day"),
}

const validationFilterDateSchema = yup.object({
    fromDate: yup
        .mixed()
        .required("Required")
        .test("is-valid-date", "Invalid date", (value) => {
            return value && dayjs(value).isValid()
        })
        .test("max-3-months", "Date cannot exceed 6 months", function (value) {
            const { toDate } = this.parent
            if (!value || !toDate) return true

            return dayjs(toDate).diff(dayjs(value), "month", true) <= 6
        }),

    toDate: yup
        .mixed()
        .required("Required")
        .test("is-valid-date", "Invalid date", (value) => {
            return value && dayjs(value).isValid()
        })
        .test("is-after-fromDate", "To Date must be after From Date", function (value) {
            const { fromDate } = this.parent

            if (!value || !fromDate) return true

            return dayjs(value).isAfter(dayjs(fromDate)) || dayjs(value).isSame(dayjs(fromDate))
        })
        .test("max-3-months", "Date cannot exceed 6 months", function (value) {
            const { fromDate } = this.parent
            if (!value || !fromDate) return true

            return dayjs(value).diff(dayjs(fromDate), "month", true) <= 6
        }),
})

const RenderToolbar = ({
    routeType,
    t, isPermissionAllow, currentData,
    navigate, selectedIds, getRoute,
    handleDelete, handlePrintLabels
}) => {

    // console.log('selectedIds', selectedIds)

    // const { listProducts: listApiProducts, filterOperatorTypes } = useProduct({ routeType })
    // const { setSystemLoading, openCustomDrawer, closeCustomDrawer } = useAppContextFeatures()
    // const { promptMessage } = useSystemPrompt()

    // const fetchRelatedProducts = async ({ selectedIds }) => {

    //     setSystemLoading(true)

    //     try {

    //         if (selectedIds.length <= 0) {
    //             throw Error(`${"Please select at least (1) item"}`)
    //         }

    //         const props = {
    //             limit: 50,
    //             skip: 0,
    //             sortInfo: {
    //                 id: "id",
    //                 dir: -1,
    //             },
    //             filterValue: [
    //                 {
    //                     name: `id`,
    //                     operator: filterOperatorTypes.anyOf,
    //                     value: JSON.stringify(selectedIds)
    //                 }
    //             ],
    //         }

    //         let { data } = await listApiProducts({
    //             props,
    //             dataTypes: [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`]
    //         })

    //         return data

    //     } catch (error) {
    //         promptMessage(false, `${error}`)
    //     } finally {
    //         setSystemLoading(false)
    //     }

    //     return []

    // }

    // const convertBarcodeSvgToDataUrl = async ({ id }) => {
    //     const svgElement = await document.getElementById(id);
    //     if (svgElement) {
    //         const dataUrl = await svgToPngDataUrl(svgElement);
    //         console.log('✅ PNG Data URL:', dataUrl);
    //         return dataUrl
    //     }
    //     console.warn('SVG element not found!');
    //     return ""
    // }

    const getToolbarMainMenus = () => {

        let props = [];

        // if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
        //     props.push({
        //         displayIconName: icons.plus,
        //         onClick: () => {

        //             navigate(getRoute("product/item/new"));

        //         }
        //     })
        // }

        if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
            props.push(
                {
                    displayIconName: icons.plus,
                    displayText: t("registerProduct"),
                    // onClick: () => {
                    //     navigate(getRoute("product/new"));
                    // }
                    url: getRoute("product/new"),
                    blank: true
                }
            )
        }

        const hostname = window.location.hostname;

        // if (getEnvConfigs().appApiProductionBaseUrl !== "https://hubapi-cn.sdgroup.com.my/api/") {
        if (hostname === "hub-my.sdgroup.com.my" || hostname === "localhost") {

            if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
                props.push({
                    displayIconName: icons.switch,
                    displayText: t("changeOwner"),
                    // onClick: () => {
                    //     navigate(getRoute("product/changeOwner"));
                    // },
                    url: getRoute("product/changeOwner"),
                    blank: true
                })
            }

        }

        if (hostname === "hub-th.sdgroup.com.my" || hostname === "localhost") {

            // if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
            //     props.push({
            //         displayIconName: icons.switch,
            //         displayText: t("printLabel"),
            //         onClick: () => {

            //             // navigate(getRoute("product/changeOwner"));

            //         }
            //     })
            // }

            props.push({
                displayText: `${t("printLabels")} (${selectedIds.length})`,
                displayIconName: icons.print,
                onClick: handlePrintLabels
            })

        }

        return props
    }

    const getActionOnClick = () => {

        let handleFunction = null

        if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
            handleFunction = handleDelete
        }

        return handleFunction
    }

    return (
        <DataGridToolbar
            selectedRowCount={
                selectedIds.length
            }
            mainMenus={
                getToolbarMainMenus()
            }
            actionOnClickRemove={
                getActionOnClick()
            }
            actionMenus={[]}
        />
    )
}

const RenderBarcodeHidden = ({ currentData, selectedIds = [] }) => {

    return (
        <Box>
            {/* {JSON.stringify(data.length)} */}
            {
                selectedIds.map((i, index) => {

                    // obtain the barcode
                    let selected = currentData.filter(i2 => i2.id === i)

                    let barcode = '0'
                    let htmlId = 0

                    if (selected.length > 0) {
                        barcode = `${selected[0][productInjectionFields.barcode.retrieveKey]}`
                        htmlId = `barcode_${selected[0].id}`
                    }

                    return (
                        <Box
                            key={index}
                            sx={{
                                float: 'left',
                                display: 'none'
                            }}
                        >
                            <Barcode
                                key={htmlId}
                                value={barcode}
                                format="CODE128"
                                htmlId={htmlId}
                            />
                        </Box>
                    )
                })
            }
        </Box>
    )

}

const RenderDialogPrintLabels = ({
    t,
    selectedIds,
    currentData,
    dialogOpen,
    onClose,
    onCancel,
    handleSubmitPrintLabels
}) => {

    let selectedData = currentData.filter(i => selectedIds.includes(i.id))

    const formik = useFormik({
        initialValues: initialPrintLabelsValues,
        validationSchema: validationPrintLabelsSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            // console.log('values', values)

            handleSubmitPrintLabels({ printNoValues: values.rows })

        },
    });

    const { values, handleSubmit, setFieldValue, handleChange, errors } = formik

    // auto fil up the input for first load
    useEffect(() => {

        let inputs = []

        selectedData.forEach(i => {

            // calc total Pack qty
            let totalPackQty = i?.items.reduce((total, item) => {
                total += parseInt(item[itemInjectionFields.packQty.retrieveKey], 10)
                return total
            }, 0)

            inputs.push({
                id: i.id,
                printNo: totalPackQty
            })

        })

        // console.log('inputs', inputs)

        setFieldValue('rows', inputs)

    }, [dialogOpen])

    return (
        <Dialog
            open={dialogOpen}
            onClose={onClose}
            maxWidth={"sm"}
        >
            <form onSubmit={handleSubmit}>
                <DialogTitle>{`${t("printLabels")} (${selectedIds.length})`}</DialogTitle>

                <DialogContent>
                    {/* {JSON.stringify(values)}
                    {JSON.stringify(errors)} */}

                    {
                        selectedData.map((i, index) => {

                            // calc total Pack qty
                            let totalPackQty = i?.items.reduce((total, item) => {
                                total += parseInt(item[itemInjectionFields.packQty.retrieveKey], 10)
                                return total
                            }, 0)

                            return (
                                <Box key={index} display={"flex"} flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>

                                    <Typography sx={{ flex: 1 }}>
                                        {i[productInjectionFields.customerMarking.retrieveKey]}
                                    </Typography>

                                    <TextField
                                        sx={{ flex: 1 }}
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        name={`rows.${index}.printNo`}
                                        label={t('printNo')}
                                        type="text"
                                        variant="outlined"
                                        value={values.rows?.[index]?.printNo || ''}
                                        onChange={handleChange}
                                        error={Boolean(errors.rows?.[index]?.printNo)}
                                        helperText={errors.rows?.[index]?.printNo}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <Typography>
                                                        / {totalPackQty}
                                                    </Typography>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />

                                </Box>
                            )
                        })
                    }
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={onCancel}
                    >
                        {t('cancel')}
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                    >
                        {t('printLabels')}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}

const RenderDataGridTable = ({
    gridRef,
    columns,
    refreshDataGrid,
    fetchData,
    isPermissionAllow,
    filterValues,
    onSelectionChange,
    onLoad
}) => {

    return (
        <DataGridTable
            ref={gridRef}
            refresh={refreshDataGrid}
            fetchData={fetchData}
            dataGrid={{
                idProperty: "id",
                style: {
                    minHeight: 600
                },
                pageSizes: [20, 50, 100],
                defaultLimit: 50,
                // defaultLimit: 2,
                defaultSkip: 0,
                checkboxColumn:
                    isPermissionAllow({ functionType: functionTypes.remove.id }),
                columns,
                defaultFilterValue: filterValues,
                onSelectionChange,

                handleOnLoad: onLoad,
                enableColumnAutosize: false,
                className: styles.dataGridCell
            }}

        />
    )

}

export default function ListProducts({
    routeType
}) {

    const [gridRef, setGridRef] = useState(null)
    const barcodeRef = useRef(null);

    const navigate = useNavigate();

    const { t } = useTranslations({ ns: ["_@products", "_@repositories", "_prompt", "_common", "common"] })

    // const [barcode, setBarcode] = useState('');

    const { promptMessage } = useSystemPrompt();
    const { defineColumns, columns, filterValues, getRenderColumnLink, hideDefaultColumns, getRenderColumnTextDisplay } = useDataGridParams('id')
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.product.id, scopeTypes.product.product.id)

    const [refreshDataGrid, setRefreshDataGrid] = useState(0)
    const [selectedIds, setSelectedIds] = useState([])
    const [selectedData, setSelectedData] = useState([])
    const { getLocationIds, setSystemLoading, openCustomDrawer, closeCustomDrawer } = useAppContextFeatures();

    const [dataContainers, setDataContainers] = useState([])
    const [currentData, setCurrentData] = useState([])
    const [productItems, setProductItems] = useState([])

    const [isHideMarking, setIsHideMarking] = useState(false)

    const [queryTrigger, setQueryTrigger] = useState(0)
    // const [dateFilter, setDateFilter] = useState(initialFilterDateValues)

    const { listProducts, deleteProducts, updateProductRemark, updateLastUpdateProduct, filterOperatorTypes } = useProduct({ routeType })
    const { listProductItems } = useProductItem({ routeType })
    const { listContainers } = useContainer({ routeType })

    const [dialogOpen, setDialogOpen] = useState(false)
    const [dialogParams, setDialogParams] = useState({})

    const { authData } = useAuthAccess();

    const [dialogPrintLabelOpen, setDialogPrintLabelOpen] = useState(false)

    const authDataUserId = `${authData?.profile?.user?.id}`
    const authDataUserDisplay = `${authData?.profile?.user?.username}`

    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const [openDateDialog, setOpenDateDialog] = useState(false)
    // const gridRef = React.createRef();

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
        setSelectedData([])
    }

    useEffect(() => {

        setRefreshDataGrid(val => val + 1)

    }, [getLocationIds])

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try {

            let encodedFilterValue = props.filterValue.map(i => {
                return {
                    ...i,
                    value: encodeURIComponent(i.value)
                }
            })

            const fromDate = dayjs(formik2.values.fromDate)
            const toDate = dayjs(formik2.values.toDate)

            encodedFilterValue.push({
                name: "ax_createdatetime",
                operator: filterOperatorTypes.moreThanEq,
                value: fromDate.startOf("day").format("YYYY-MM-DD HH:mm:ss")
            })

            encodedFilterValue.push({
                name: "ax_createdatetime",
                operator: filterOperatorTypes.lessThanEq,
                value: toDate.endOf("day").format("YYYY-MM-DD HH:mm:ss")
            })

            if (!props?.sortInfo) {
                props.sortInfo = {
                    id: `ax_createdatetime`,
                    dir: -1
                }
            }

            // if (checkIsOwnerUser() === false) {
            props.customFilterLocationEnable = true;
            props.customFilterLocationFields = [productInjectionFields.registerLocationId.retrieveKey]
            props.filterValue = encodedFilterValue
            // props.filterValue.map(i => i[productInjectionFields.customerMarking.retrieveKey])
            // console.log('props', props)
            // } else {
            //     props.customFilterLocationEnable = false;
            // }

            let dataTypes = [
                `${getInjectionDataType('product')}`,
                `${getInjectionDataType('item')}`
            ]

            const { data, count } = await listProducts({ props, dataTypes })

            console.log('Data Product-->', data)

            // const itemIds = []

            // data.forEach((i) => {
            //     i.items.forEach(i2 => {
            //         if (itemIds.includes(i2?.id) === false) {
            //             itemIds.push(i2.id)
            //         }
            //     })
            // })

            // console.log('itemIds', itemIds)

            // // for items query
            // if (itemIds.length > 0) {

            //     const props = {
            //         limit: -1,
            //         skip: 0,
            //         filterValue: [],
            //         sortInfo: {
            //             id: "id",
            //             dir: 0,
            //         }
            //     }

            //     const { data } = await listProductItems({ props, itemIds })

            //     console.log('datai items: ', data)

            //     setProductItems(data)
            // }

            // get the container ids if any
            let _dataProducts = data

            let containerIds = []

            _dataProducts.forEach(i => {
                if (i[productInjectionFields.loadContainerId.retrieveKey]) {
                    if (containerIds.includes(i[productInjectionFields.loadContainerId.retrieveKey]) === false) {
                        containerIds.push(i[productInjectionFields.loadContainerId.retrieveKey])
                    }
                }
            })

            if (containerIds.length > 0) {

                const props = {
                    limit: -1,
                    skip: 0,
                    filterValue: [],
                    sortInfo: {
                        id: "id",
                        dir: 0,
                    }
                }

                // let _dataContainers = await fetchContainers({ containerIds })

                const { data } = await listContainers({ props, containerIds })
                setDataContainers(data)
            }

            setCurrentData(_dataProducts)
            return { data: _dataProducts, count }

        } catch (error) {
            promptMessage(false, `Error getting results (${error?.message})`)
            return { data: [], count: 0 }
        }
    }

    const updateProductRemarkIP = async ({ productId, sourceProductRemId, remark }) => {

        setSystemLoading(true)

        try {

            let _sourceProductRemId = sourceProductRemId

            if (!_sourceProductRemId) {
                throw Error(`sourceProductRemId is Required`)
            }

            // console.log('gridRef', gridRef)

            await updateProductRemark({ productId, remark })

            let _p = {
                productId,
                lastUpdateUserId: authDataUserId,
                lastUpdateUserDisplay: authDataUserDisplay
            }

            await updateLastUpdateProduct(_p)

            setSystemLoading(false)

            promptMessage(true, `${t("savedSuccess")}`)

            gridRef?.current.reload()

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }


        setSystemLoading(false)

        return false

    }

    const handleDelete = async () => {

        try {

            let productSelectedInfo = currentData.filter(i => selectedIds.includes(i.id))

            let productHasLoaded = productSelectedInfo.filter(i => i[productInjectionFields.loadStatus.retrieveKey] === "loaded")

            if (productHasLoaded.length > 0) {
                throw Error(t("Unable to remove, there is one of the selected product has been loaded."))
            }

            await deleteProducts({ selectedData, selectedIds })
            promptMessage(true, t("productsSuccessDeleted"))

            gridRef?.current.reload()
            resetDataGridTableSelection();

            // setRefreshDataGrid(val => val + 1)

        } catch (error) {
            promptMessage(false, t(error, { no: selectedData.length }))
        }

        // setSystemLoading(false)

        return true
    }

    const onSearchBarcode = async (currentValues) => {

        setSystemLoading(true)

        try {

            console.log('currentValues', currentValues)

            let { searchBarcode } = currentValues

            const props = {
                limit: -1,
                skip: 0,
                filterValue: [{
                    name: `${productInjectionFields.barcode.retrieveKey}`,
                    operator: filterOperatorTypes.eq,
                    value: `${searchBarcode}`,
                }],
                sortInfo: {
                    id: 'id',
                    dir: 0,
                },
            };

            let dataTypes = [`${getInjectionDataType('product')}`]
            let { data, count } = await listProducts({ props, dataTypes })

            if (data.length <= 0) {
                throw Error(`Invalid barcode`)
            }

            let productId = data[0].id
            window.open(getRoute(`product/item/update/${productId}`), "_blank");

        } catch (error) {
            promptMessage(false, `Error getting results (${error})`)
        }
        setSystemLoading(false)
    }

    const onDateFilter = async () => {
        const errors = await formik2.validateForm()

        if (Object.keys(errors).length > 0) return

        setQueryTrigger(prev => prev + 1) // ✅ ONLY trigger
    }

    const handleDatefilter = async () => {
        const { fromDate, toDate } = formik2.values

        // ✅ Formik basic validation
        const errors = await formik2.validateForm()
        if (Object.keys(errors).length > 0) {
            promptMessage(false, "Please fill in all required fields correctly")
            return
        }

        const from = dayjs(fromDate)
        const to = dayjs(toDate)

        // ✅ custom validation
        if (to.isBefore(from)) {
            promptMessage(false, "To Date must be after From Date")
            return
        }

        const isValidRange = to.diff(from, "month", true) <= 3

        if (!isValidRange) {
            promptMessage(false, "Date range cannot exceed 3 months")
            return
        }

        // ✅ valid → trigger fetch
        setQueryTrigger(prev => prev + 1)
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit: onSearchBarcode,
    });

    const formik2 = useFormik({
        initialValues: initialFilterDateValues,
        validationSchema: validationFilterDateSchema,
        enableReinitialize: true,
        onSubmit: () => {

            // const formatted = {
            //     fromDate: dayjs(values.fromDate).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
            //     toDate: dayjs(values.toDate).endOf("day").format("YYYY-MM-DD HH:mm:ss"),
            // }

            // setDateFilter(formatted) // values
            // dateFilterRef.current = formatted

            if (!formik2.isValid) return

            setRefreshDataGrid(prev => prev + 1) // trigger reload
        }
    });

    const { values, errors, handleChange, setFieldValue, handleSubmit } = formik;

    useEffect(() => {
        hideDefaultColumns()
        defineColumnsView()
    }, [])

    useEffect(() => {
        // hideDefaultColumns()
        defineColumnsView()
    }, [dataContainers])

    useEffect(() => {
        if (queryTrigger === 0) return

        setRefreshDataGrid(prev => prev + 1)
    }, [queryTrigger])

    const handleHideMarking = (event) => {
        setIsHideMarking(event.target.checked)
    }

    useEffect(() => {
        setRefreshDataGrid(val => val + 1)
    }, [isHideMarking])

    // console.log('currentData -->', currentData)

    const defineColumnsView = () => {

        defineColumns([

            // {
            //     name: "item_name",
            //     header: "Name",
            //     renderValue: ({ value, cellProps }) => {

            //         if (isPermissionAllow({ functionType: functionTypes.pageView.id }) === false) {
            //             return getRenderColumnTextDisplay(value)
            //         }

            //         let path = getRoute(`product/item/update/${cellProps.data.id}`);

            //         return getRenderColumnLink(path, value)

            //     }
            // }

            {
                name: productInjectionFields.registerLocationDisplay.retrieveKey,
                header: t("location"),
                textAlign: 'center',
                defaultFlex: 0,
                defaultWidth: 60,
                // style: { color: 'red' }
                cellProps: () => ({ style: { color: 'red !important' } })
            },
            {
                name: `id`,
                header: t("systemId"),
                textAlign: 'center',
                defaultFlex: 0,
                defaultWidth: 70,
            },
            {
                name: productInjectionFields.customerMarking.retrieveKey,
                header: t("marking"),
                defaultFlex: 0,
                defaultWidth: 220,
                renderValue: ({ value, cellProps }) => {

                    if (isPermissionAllow({ functionType: functionTypes.pageView.id }) === false) {
                        return getRenderColumnTextDisplay(value)
                    }

                    let path = getRoute(`product/item/update/${cellProps.data.id}`);

                    return (
                        <Box
                            display={"flex"}
                            justifyContent={"flex-start"}
                            alignItems={"center"}
                        >
                            {/* {
                                isPermissionAllow({ functionType: functionTypes.pageNew.id }) &&
                                <Box
                                    sx={{
                                        mr: 0.5
                                    }}
                                >
                                    <IconButton
                                        size='small'
                                        color='primary'
                                    >
                                        <CommonIcons name={icons.switch} />
                                    </IconButton>
                                </Box>
                            } */}
                            <Tooltip
                                title={value}
                            >
                                {/* {getRenderColumnLink(path, value)} */}
                                <Link
                                    href={path}
                                    target="_blank"
                                >{value}</Link>
                            </Tooltip>
                        </Box>
                    )

                }
            },
            {
                name: productInjectionFields.checkinDateTime.retrieveKey,
                header: t("checkedInAt"),
                textAlign: 'center',
                defaultFlex: 0,
                defaultWidth: 180,
                renderValue: ({ value, cellProps }) => {
                    return dayjs(value).format("YYYY-MM-DD HH:mm:ss")
                }
            },
            {
                // name: productInjectionFields.appPrintPackQty.retrieveKey,
                name: "item_name",
                header: t("packUnit"),
                sortable: false,
                textAlign: 'center',
                defaultFlex: 0,
                defaultWidth: 80,
                renderValue: ({ value, cellProps }) => {

                    let items = cellProps?.data?.items ? cellProps.data.items : []
                    let totalPackQty = items.reduce((total, i) => {
                        total += parseInt(i[itemInjectionFields.packQty.retrieveKey], 10)
                        return total
                    }, 0)

                    return (
                        <Typography sx={{ fontSize: 13 }}>
                            {/* {parseFloat(value).toFixed(0)} */}
                            {parseFloat(totalPackQty).toFixed(0)}
                        </Typography>
                    )
                }
            },
            {
                name: "brand_name",
                header: t("tCbm"),
                sortable: false,
                textAlign: 'center',
                defaultFlex: 0,
                defaultWidth: 80,
                renderValue: ({ value, cellProps }) => {

                    let items = cellProps?.data?.items ? cellProps.data.items : []

                    // console.log('items', items)

                    let totalCbm = items.reduce((total, i) => {
                        // console.log('i', i)
                        total += parseFloat(i[itemInjectionFields.totalCbm.retrieveKey])
                        return total
                    }, 0)

                    // console.log('totalCbm', totalCbm)

                    return (
                        <Typography
                            sx={{
                                fontSize: 13
                            }}
                        >
                            {
                                totalCbm.toFixed(4)
                            }
                        </Typography>
                    )

                }
            },
            {
                name: productInjectionFields.supplierName.retrieveKey,
                header: t("supplier"),
                defaultFlex: 0,
                defaultWidth: 120,
            },
            {
                name: productInjectionFields.courierTrackingNo.retrieveKey,
                header: t("courierNo"),
                defaultFlex: 0,
                defaultWidth: 160,
                renderValue: ({ value, cellProps }) => {

                    return value;

                    // if (isPermissionAllow({ functionType: functionTypes.pageView.id }) === false) {
                    //     return getRenderColumnTextDisplay(value)
                    // }

                    // let path = getRoute(`product/item/update/${cellProps.data.id}`);

                    // return getRenderColumnLink(path, value)

                }
            },
            {
                name: productInjectionFields.signedByUserDisplay.retrieveKey,
                header: t("signedByUser"),
                defaultFlex: 0,
                defaultWidth: 100,
            },
            {
                name: productInjectionFields.remark.retrieveKey,
                header: t('remark'),
                defaultFlex: 0,
                defaultWidth: 140,
                renderValue: ({ value, cellProps }) => {

                    // let value = params?.row[productInjectionFields.remark.retrieveKey]

                    return (
                        <Tooltip
                            title={value}
                        >
                            <Box
                                display={"flex"}
                                flexDirection={"row"}
                                justifyContent={"flex-start"}
                                alignItems={"center"}
                            >

                                <IconButton
                                    color="primary"
                                    onClick={() => {
                                        setDialogOpen(true)
                                        setDialogParams({
                                            productId: cellProps.data?.id,
                                            sourceProductRemId: cellProps.data[productInjectionFields.sourceProductRemId.retrieveKey],
                                            remark: value
                                        })
                                        // console.log('cellProps.data[productInjectionFields.sourceProductRemId.retrieveKey]', cellProps.data[productInjectionFields.sourceProductRemId.retrieveKey])
                                    }}
                                >
                                    <CommonIcons name={icons.edit} />
                                </IconButton>
                                <Typography
                                    sx={{
                                        fontSize: 13
                                    }}
                                >
                                    {value}
                                </Typography>
                            </Box>
                        </Tooltip>
                    )
                }

            },
            {
                name: productInjectionFields.loadStatus.retrieveKey,
                header: t("status"),
                textAlign: "center",
                defaultFlex: 0,
                defaultWidth: 280,
                renderValue: ({ value, cellProps }) => {

                    let _value = value ? value.toLowerCase() : ''

                    let loadContainerId = cellProps.data[productInjectionFields.loadContainerId.retrieveKey]

                    const containerInfo = dataContainers.find(i => i?.id === loadContainerId)

                    let colorStatus = ''
                    let variantStatus = ''

                    const markingDisplay = containerInfo?.number_marking || ""

                    if (_value === productLoadStatusTypes.loaded.id) {
                        colorStatus = 'success'
                        variantStatus = 'contained'
                    }
                    else {
                        colorStatus = 'secondary'
                        variantStatus = 'outlined'
                    }


                    return (
                        (isHideMarking === false) ?
                            <Chip
                                color={colorStatus}
                                variant={variantStatus}
                                // label={`${t(_value)} ${markingDisplay}`}
                                label={
                                    markingDisplay
                                        ? `${t(_value)} ${markingDisplay}`
                                        : `${t(_value)}`
                                }
                                size='small'
                            />
                            :
                            <Tooltip title={markingDisplay || ""}>
                                <Chip
                                    color={colorStatus}
                                    variant={variantStatus}
                                    label={`${t(_value)}`}
                                    size='small'
                                />
                            </Tooltip>
                    )
                },
                filter: {
                    type: dataGridFilterTypes.select,
                    props: {
                        placeholder: 'Any',
                        dataSource: [
                            {
                                id: productLoadStatusTypes.loaded.id,
                                label: t(productLoadStatusTypes.loaded.id)
                            },
                            {
                                id: productLoadStatusTypes.pending.id,
                                label: t(productLoadStatusTypes.pending.id)
                            }
                        ]
                    }
                }
            },
            {
                name: productInjectionFields.supplierContact.retrieveKey,
                header: t("supplierContact"),
                defaultFlex: 0,
                defaultWidth: 140,
            },
            {
                name: productInjectionFields.supplierPurchaseNumber.retrieveKey,
                header: t("supplierPurchaseNo"),
                defaultFlex: 0,
                defaultWidth: 140,
            },
            {
                name: productInjectionFields.companyPurchaseNumber.retrieveKey,
                header: t("companyPurchaseNo"),
                defaultFlex: 0,
                defaultWidth: 140,
            },
            {
                name: productInjectionFields.barcode.retrieveKey,
                header: t('barcode'),
                defaultFlex: 0,
                defaultWidth: 185,
            },
            {
                name: productInjectionFields.isSplit.retrieveKey,
                header: t("split"),
                defaultFlex: 0,
                defaultWidth: 100,
                renderValue: ({ value, cellProps }) => {

                    let _value = value === '1' ? `isSplit` : 'notSplit'

                    return (
                        <Typography
                            sx={{
                                fontSize: 13,
                                // fontWeight: '800'
                            }}
                        >
                            {t(_value).toUpperCase()}
                        </Typography>
                    )

                },
                filter: {
                    type: dataGridFilterTypes.select,
                    props: {
                        placeholder: 'Any',
                        dataSource: [
                            {
                                id: `1`,
                                label: `${t('isSplit')}`
                            },
                            {
                                id: `0`,
                                label: `${t("notSplit")}`
                            }
                        ]
                    }
                }
            },
            {
                name: productInjectionFields.splitFromRemId.retrieveKey,
                header: `${t("splitId")}`,
                defaultFlex: 0,
                defaultWidth: 200,
            },
            {
                name: productInjectionFields.sourceProductRemId.retrieveKey,
                header: `sourceProductRemId`,
                defaultFlex: 0,
                defaultWidth: 250,
            },
            {
                name: `ax_createdatetime`,
                header: t("createdAt"),
                defaultFlex: 0,
                defaultWidth: 150,
            },
            {
                name: `ax_createusername`,
                header: t("createdBy"),
                defaultFlex: 0,
                defaultWidth: 150,
            },
            {
                name: `${productInjectionFields.lastUpdateUserDisplay.retrieveKey}`,
                header: t("updatedBy"),
                defaultFlex: 0,
                defaultWidth: 150,
            },
            {
                name: `${productInjectionFields.lastUpdateDatetime.retrieveKey}`,
                header: t("updatedAt"),
                defaultFlex: 0,
                defaultWidth: 170,
            }
            // {
            //     name: "status",
            //     header: "Status",
            //     renderValue: ({ cellProps, value }) => getRenderColumnBooleanDisplay(value, ["Enabled", "Disabled"], ["primary", "default"], "")
            // }
        ])
    }

    const handleSubmitPrintLabels = async ({ printNoValues }) => {

        console.log('printNoValues', printNoValues)

        // // get the all checkbox selected id
        let selectedData = currentData.filter(i => selectedIds.includes(i.id))

        // getting the values rows selected qrcode
        selectedData.forEach(async (i, index) => {

            // adding the qrcode
            let dataUrl = document.getElementById(`barcode_${i.id}`).toDataURL()
            selectedData[index].barcodeDataUrl = dataUrl

            // adding the print no 
            let selectedPrintNo = printNoValues.filter(i2 => i2.id === i.id)

            if (selectedPrintNo.length > 0) {
                selectedData[index].printNo = selectedPrintNo[0].printNo
            }

        })

        console.log('selectedData', selectedData)

        // multiply the print qty for pages in pdf
        let pdfItems = []

        selectedData.forEach((i) => {

            // let _items = i?.items
            let printNo = parseInt(i?.printNo, 10)
            // let totalPrintQty = _items.reduce((_total, _index) => {
            //     _total += parseInt(_index[itemInjectionFields.packQty.retrieveKey], 10)
            //     return _total
            // }, 0)

            for (let n = 0; n < printNo; n += 1) {
                pdfItems.push(i)
            }

        })

        let data = {
            items: pdfItems
        }

        openCustomDrawer({
            show: true,
            anchor: "right",
            title: `${t("printLabels")} (${selectedData.length})`,
            PaperProps: {
                sx: { width: 3 / 5 }
            },
            handleOnClose: () => {
                closeCustomDrawer()
                // setRefreshDataGrid(val => val + 1)
            },
            ComponentActions:
                <></>,
            ComponentBody:
                <CommonPdf
                    routeType={routeType}
                    renderMode={renderModes.preview.id}
                    documentType={commonPdfDocumentTypes.product.id}
                    document={{
                        title: "-"
                    }}
                    data={data}
                    canvasStyle={{
                        height: '100vh'
                    }}
                />
        })

        setDialogPrintLabelOpen(false)

    }

    const handlePrintLabels = async () => {
        setDialogPrintLabelOpen(true)
    }

    // console.log("dataContainersInfo >>>", dataContainers)

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: t("products") })
            }
            {/* [{JSON.stringify(barcode)}] */}
            {/* {
                JSON.stringify(dataGridState)
            } */}
            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("products")}
                breadcrumbs={[
                    {
                        displayText: `${t("products")} (*)`,
                        props: {}
                    }
                ]}
            />

            {/* {JSON.stringify(selectedIds)}
            {JSON.stringify(selectedData)} */}
            <RenderBarcodeHidden
                selectedIds={selectedIds}
                currentData={currentData}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <Box sx={{ position: 'relative' }}>
                        <Box
                            display={'flex'}
                            flexDirection={'row'}
                            justifyContent={'flex-end'}
                            alignItems={'flex-end'}
                            sx={{ position: 'absolute', top: 12, right: 70 }}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        onChange={handleHideMarking}
                                    // icon={
                                    //     <CommonIcons name={(isHideMarking === false) ? icons.reveal : icons.hide} />
                                    // }
                                    />
                                }
                                label={
                                    (isHideMarking === false) ? t('openMarking') : t('hideMarking')
                                }
                                sx={{ alignSelf: 'center' }}
                            />

                            <form onSubmit={formik.handleSubmit}>
                                <FormControl
                                    size="small"
                                    error={Boolean(errors.searchBarcode)}
                                >
                                    <TextField
                                        // autoFocus
                                        // required
                                        // margin="dense"
                                        size='small'
                                        id="searchBarcode"
                                        name="searchBarcode"
                                        label={t("searchBarcode")}
                                        type="text"
                                        value={values.searchBarcode}
                                        onChange={handleChange}
                                        fullWidth
                                        // variant="standard"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton type='submit' edge="end">
                                                        <CommonIcons name={icons.search} />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        onFocus={event => {
                                            event.target.select();
                                        }}
                                        sx={{ width: 290 }}
                                    />
                                    <FormHelperText>{errors?.searchBarcode}</FormHelperText>
                                </FormControl>
                            </form>
                        </Box>

                        <Box
                            display={'flex'}
                            flexDirection={'row'}
                            justifyContent={'center'}
                            alignItems={'center'}
                            sx={{
                                position: 'absolute',
                                right: 530,
                                my: 2,
                            }}
                            flexWrap="nowrap"
                        >
                            {/* onSubmit={formik2.handleSubmit} */}
                            <Tooltip title={t("dateFilter")}>
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    onClick={() => setOpenDateDialog(true)}
                                >
                                    {dayjs(formik2.values.fromDate).format("DD/MM/YYYY")} -{" "}
                                    {dayjs(formik2.values.toDate).format("DD/MM/YYYY")}
                                </Button>
                            </Tooltip>
                        </Box>

                        <RenderToolbar
                            routeType={routeType}
                            t={t}
                            currentData={currentData}
                            isPermissionAllow={isPermissionAllow}
                            navigate={navigate}
                            selectedIds={selectedIds}
                            getRoute={getRoute}
                            handleDelete={handleDelete}
                            openCustomDrawer={openCustomDrawer}
                            closeCustomDrawer={closeCustomDrawer}
                            promptMessage={promptMessage}
                            handlePrintLabels={handlePrintLabels}
                        />

                        <RenderDataGridTable
                            gridRef={gridRef}
                            columns={columns}
                            refreshDataGrid={refreshDataGrid}
                            fetchData={fetchData}
                            isPermissionAllow={isPermissionAllow}
                            filterValues={filterValues}
                            onSelectionChange={(items) => {
                                setSelectedIds(items)
                                setSelectedData(selectedData)
                            }}
                            onLoad={({ ref }) => {
                                if (ref) {
                                    setGridRef(ref)
                                }
                            }}
                        />
                        {/* <DataGridTable
                            // gridRef={gridRef}
                            // refreshDataGrid={refreshDataGrid}
                            fetchData={(props) => {

                                // props.filterValue.push({
                                //     name: productInjectionFields.registerLocationId.retrieveKey,
                                //     operator: filterOperatorTypes.anyOf,
                                //     value: JSON.stringify(availableLocationIds)
                                // })

                                // console.log('a', props)

                                return fetchData(props)
                            }}
                            dataGrid={{
                                handleOnLoad: ({ ref }) => {
                                    if (ref) {
                                        setGridRef(ref)
                                    }
                                },
                                idProperty: "id",
                                style: {
                                    // minHeight: 600
                                    // width: 3000
                                },
                                checkboxColumn:
                                    isPermissionAllow({ functionType: functionTypes.remove.id }),
                                columns,
                                defaultFilterValue: filterValues,
                                onSelectionChange: (items, selectedData) => {
                                    // console.log('items', items, selectedData)
                                    setSelectedIds(items)
                                    setSelectedData(selectedData)
                                },
                                defaultLimit: 50,
                                // defaultSkip: dataGridState?.skip,
                                // onSkipChange: (val) => {
                                //     console.log('change page', val)
                                //     if (stayCurrentDataGridState === false) {
                                //         setDataGridState({
                                //             ...dataGridState,
                                //             skip: val
                                //         })
                                //     }
                                // },
                                enableColumnAutosize: false
                            }}
                        /> */}
                    </Box>
                    :
                    (
                        <CommonRestricted />
                    )
            }

            <Dialog
                open={dialogOpen}
                onClose={() => {
                    setDialogOpen(false)
                    setDialogParams({})
                }}
                maxWidth="false"
            >
                <div style={{ width: 700 }}>
                    <DialogTitle>{t('updateRemark')}</DialogTitle>

                    <DialogContent>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="name"
                            name="remark"
                            label={t("remark")}
                            type="text"
                            multiline
                            value={dialogParams?.remark ? dialogParams.remark : ""}
                            onChange={(e) => {
                                setDialogParams({
                                    ...dialogParams,
                                    remark: e.target.value
                                })
                            }}
                            fullWidth
                            variant="standard"
                        />
                    </DialogContent>
                </div>

                <DialogActions>
                    <Button
                        onClick={
                            () => {
                                setDialogOpen(false)
                                setDialogParams({})
                            }
                        }
                    >
                        {t('cancel')}
                    </Button>
                    <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={async () => {

                            console.log('dialogParams', dialogParams)

                            await updateProductRemarkIP({
                                productId: dialogParams?.productId,
                                sourceProductRemId: dialogParams?.sourceProductRemId,
                                remark: dialogParams?.remark
                            })

                            setDialogOpen(false)
                            setDialogParams({})

                            // loadData(id)
                            // setRefreshDataGrid(val => val + 1)

                            // setStayCurrentDataGridState(true)
                        }}
                    >
                        {t('saveChanges')}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Date Filter */}
            <Dialog
                open={openDateDialog}
                onClose={() => setOpenDateDialog(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>{t("dateFilter")}</DialogTitle>

                <DialogContent>
                    <Stack spacing={2} mt={1}>
                        <DatePickerComponent
                            config={{
                                name: "fromDate",
                                label: t("fromDate")
                            }}
                            formik={formik2}
                        />

                        <DatePickerComponent
                            config={{
                                name: "toDate",
                                label: t("toDate")
                            }}
                            formik={formik2}
                        />
                    </Stack>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenDateDialog(false)}>
                        {t("cancel")}
                    </Button>

                    <Button
                        variant="contained"
                        onClick={() => {
                            onDateFilter()
                            setOpenDateDialog(false)
                        }}
                        disabled={!formik2.isValid}
                    >
                        {t("apply")}
                    </Button>
                </DialogActions>
            </Dialog>

            <RenderDialogPrintLabels
                t={t}
                selectedIds={selectedIds}
                currentData={currentData}
                dialogOpen={dialogPrintLabelOpen}
                onClose={() => {
                    setDialogPrintLabelOpen(false)
                    // setDialogParams({})
                }}
                onCancel={() => {
                    setDialogPrintLabelOpen(false)
                    setDialogParams({})
                }}
                handleSubmitPrintLabels={handleSubmitPrintLabels}
            />


        </Box>
    )
}
